(() => {
  if (!document.querySelector('.alv-kaki-gallery')) return;
  const quantities = [2, 4, 8];
  const names = ["Na próbę", "Pełna rutyna", "Dla całej rodziny"];
  const format = new Intl.NumberFormat('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let observer;
  let scheduled = false;

  function apply() {
    scheduled = false;
    const moon = document.querySelector('moonbundle-component');
    if (!moon) return;
    const heading = moon.querySelector('.moonbundle-title');
    if (heading && heading.textContent.trim() !== 'WYBIERZ ZESTAW') {
      heading.textContent = 'WYBIERZ ZESTAW';
    }
    const cards = moon.querySelectorAll('.moonbundle-option-wrapper');
    if (cards.length !== 3) return;
    cards.forEach((card, i) => {
      const col = card.querySelector('.moonbundle-option-col-inner');
      const price = card.querySelector('.moonbundle-option-price');
      const pack = card.querySelector('.moonbundle-option-single-price');
      if (!col || !price || !pack) return;
      let name = col.querySelector('.alv-kaki-cz-season');
      if (!name) {
        name = document.createElement('span');
        name.className = 'alv-kaki-cz-season';
        col.prepend(name);
      }
      if (name.textContent !== names[i]) name.textContent = names[i];
      const raw = (pack.textContent.match(/[\d.,\s\u00a0]+/) || [''])[0].replace(/[\s\u00a0.]/g, '').replace(',', '.');
      const total = Number(raw);
      if (!Number.isFinite(total) || total <= 0) return;
      const expected = `${format.format(total / quantities[i])} zł`;
      if (pack.dataset.unit !== expected) pack.dataset.unit = expected;
      const displayTotal = pack.textContent.trim();
      if (pack.dataset.total !== displayTotal) pack.dataset.total = displayTotal;
      price.setAttribute('aria-label', `${expected} za mydło, razem ${displayTotal}`);
    });
    const urgency = document.querySelector('.alv-kaki-urgency');
    if (urgency && moon.nextElementSibling !== urgency) moon.after(urgency);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }

  function init() {
    const moon = document.querySelector('moonbundle-component');
    if (!moon) return;
    schedule();
    observer = new MutationObserver(schedule);
    observer.observe(moon, { childList: true, subtree: true });
    moon.addEventListener('click', () => setTimeout(schedule, 0));
    setTimeout(schedule, 300);
    setTimeout(schedule, 1200);
    const clock = document.querySelector('.alv-kaki-cz-count');
    if (clock) {
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(23, 59, 59, 999);
        const seconds = Math.max(0, Math.floor((end - now) / 1000));
        const two = n => String(n).padStart(2, '0');
        clock.textContent = `${two(Math.floor(seconds / 3600))}:${two(Math.floor((seconds % 3600) / 60))}:${two(seconds % 60)}`;
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
